import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HomePage from '@/pages/HomePage';
import FeaturesPage from '@/pages/FeaturesPage';
import PricingPage from '@/pages/PricingPage';
import ContactPage from '@/pages/ContactPage';
import AboutPage from '@/pages/AboutPage';
import PartnershipsPage from '@/pages/PartnershipsPage';
import { PrivacyPolicy } from '@/pages/PrivacyPolicy';
import { TermsAndConditions } from '@/pages/TermsAndConditions';
import { CookiePolicy } from '@/pages/CookiePolicy';
import LoginPage from '@/pages/LoginPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import SignupPage from '@/pages/SignupPage';
import PortfolioPage from '@/pages/PortfolioPage';
import PortfolioBlogPostPage from '@/pages/PortfolioBlogPostPage';
import BillingConsolePage from '@/pages/BillingConsolePage';
import PromoPage from '@/pages/PromoPage';
import HowItWorksPage from '@/pages/HowItWorksPage';
import { RefundPolicy } from '@/pages/RefundPolicy';
import { Toaster } from '@/components/ui/toaster';
import { shouldShowMarketingShell } from '@/constants/siteRoutes';

const AppShell: React.FC = () => {
  const location = useLocation();
  const marketing = shouldShowMarketingShell(location.pathname);
  const isPromo = location.pathname === '/promo';

  return (
    <div className="min-h-screen flex flex-col">
      {marketing ? <Header /> : null}
      <main className={isPromo ? 'flex-grow flex flex-col min-h-0' : 'flex-grow'}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/partnerships" element={<PartnershipsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/promo" element={<PromoPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/billing" element={<BillingConsolePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/:portfolioSlug/blogs/:blogSlug" element={<PortfolioBlogPostPage />} />
          <Route path="/:portfolioSlug" element={<PortfolioPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {marketing && !isPromo ? <Footer /> : null}
      <Toaster />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppShell />
    </Router>
  );
};

export default App;
